import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import { connect } from 'react-redux'
import { history } from '../store'
import App from '../components/App'
import LoginForm from '../components/LoginForm'
import WorkcenterSelect from '../components/WorkcenterSelect'
import Productions from '../components/Productions'
import Operations from '../components/Operations'
import OperationView from '../components/OperationView'

const PrivateRoute = ({ component: Component, authenticated, ...rest }) => (
  <Route {...rest} render={(props) => (
    authenticated === true
      ? <Component {...props} />
      : <Redirect to='/login' />
  )} />
)

const mapStateToProps = state => ({
  authenticated: state.auth.session.token !== false,
  pendingToken: state.auth.pendingToken,
  production: state.router.location.query.production
    ? parseInt(state.router.location.query.production, 10) : false,
  operation: state.router.location.query.operation
    ? parseInt(state.router.location.query.operation, 10) : false
})

class RoutesComponent extends React.Component {
  loadComponent = () => {
    const { authenticated, production, operation } = this.props
    if (!authenticated) return LoginForm
    if (operation) return OperationView
    if (production) return Operations
    return Productions
  }

  render() {
    const { authenticated, pendingToken } = this.props
    const View = this.loadComponent()
    return (
      <ConnectedRouter history={history}>
        <App>
          <Route path="/login" render={() => (
            pendingToken ? <WorkcenterSelect /> : <LoginForm />
          )} />
          <PrivateRoute exact path="/" authenticated={authenticated} component={View} />
        </App>
      </ConnectedRouter>
    )
  }
}
const Routes = connect(mapStateToProps)(RoutesComponent)

export default Routes
